import { SplashVisibilityParams } from '../types';

const SPLASH_ENABLED_DOMAINS = [
  'portal.valori.com.vc',
  'localhost',
  'portalhml.valori.com.vc',
  'happy-mushroom-0f6683910.4.azurestaticapps.net',
];

const BLOCKED_PROFILES = [
  3, // Administrador
  7, // White Label
];

export const isBlockedProfile = (profileId: number): boolean =>
  BLOCKED_PROFILES.includes(profileId);

export const isWhiteLabelDomain = (): boolean =>
  !SPLASH_ENABLED_DOMAINS.includes(window.location.hostname);

export const shouldDisplaySplash = ({
  splash,
  profileId,
}: SplashVisibilityParams): boolean => {
  if (!splash) return false;
  if (isBlockedProfile(profileId)) return false;
  if (isWhiteLabelDomain()) return false;
  return true;
};